import { render, staticRenderFns } from "./ShortcutForm.vue?vue&type=template&id=496d7a94"
import script from "./ShortcutForm.vue?vue&type=script&lang=js"
export * from "./ShortcutForm.vue?vue&type=script&lang=js"
import style0 from "./ShortcutForm.vue?vue&type=style&index=0&id=496d7a94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports